<template>
  <article class="pricing_container">
    <h3 class="wow bounceIn">{{ title }}</h3>
    <section class="pricing_list">
      <div
        class="wow fadeInUp priceCart"
        v-for="(version, index) in data"
        :key="index"
      >
        <div class="header">
          <h4>{{ version.name }}</h4>
          <h4 class="price">
            <!-- {{ ((version.costInUSD*usdRate)>0?Math.ceil(version.costInUSD*usdRate):version.costInEGP )+ " " }} -->
            {{ version.costInEGP + " " }}
            <span> {{ currency }}</span>
          </h4>

          <div class="img_container">
            <svg
              viewBox="0 0 500 150"
              preserveAspectRatio="none"
              style="height: 100%; width: 100%"
            >
              <path
                d="M-1.01,148.31 C-1.58,55.55 484.87,110.81 506.31,-10.55 L504.62,-10.55 L0.00,0.00 Z"
                style="stroke: none; fill: #364751"
              ></path>
            </svg>
          </div>
        </div>

        <div class="content">
          <div class="featuresContainer">
            <p v-for="(spec, index) in version.spacificationList" :key="index">
              <i class="far fa-check-circle"></i>
              {{ spec }}
            </p>
          </div>
        </div>
        <button @click="buyVersion(version)">{{ version.btnText }}</button>
      </div>
      <ModalComponent v-model="isShow" :close="closeModal">
        <section class="modal_container">
          <SendClientDataToBuy
            class="submit_Container show-up"
            v-bind="propObj"
          />
        </section>
      </ModalComponent>
    </section>
  </article>
</template>

<script>
import SendClientDataToBuy from "@/components/SendClientDataToBuy";
export default {
  data() {
    return {
      isShow: false,
      propObj: {},
    };
  },
  components: {
    SendClientDataToBuy,
  },
  name: "ProjectPagePricing",
  props: ["projectName", "title", "data", "designYourNeeds"],
  methods: {
    closeModal() {
      this.isShow = false;
    },
    buyVersion(version) {
      this.propObj = {
        currency: this.currency,
        designYourNeeds: this.designYourNeeds,
        submitAction: "submitAction",
        totalPrice: version.costInEGP,
        closeModal: this.closeModal,
        versionName: version.name,
        programName: this.projectName,
      };
      this.isShow = true;
    },
  },
  computed: {
    currency() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].currency;
    },
    usdRate() {
      const { lang } = this.$store.state;
      console.log(this.$store.state[lang].usdRate);
      return this.$store.state[lang].usdRate;
    },
  },
};
</script>
